"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactResponsive = require("react-responsive");

var _Image = require("../Image");

var _hooks = require("../../hooks");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var desktopSize = {
  width: 120,
  maxHeight: 120
};
var mobileSize = {
  width: 120,
  maxHeight: 120
};

var EmployerLogo = function EmployerLogo(_ref) {
  var src = _ref.src;
  var theme = (0, _hooks.useTheme)();
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    query: (0, _helpers.breakpoint)('maxMobile')({
      theme: theme
    })
  });
  var size = isMobile ? mobileSize : desktopSize;
  return _react.default.createElement(_Image.Image, {
    src: src,
    width: size.width,
    imgixParams: {
      fit: 'fill',
      bg: 'transparent',
      'max-h': size.maxHeight,
      auto: 'compress,format'
    },
    htmlAttributes: {
      style: {
        maxWidth: "".concat(size.width, "px"),
        maxHeight: "".concat(size.maxHeight, "px")
      }
    },
    attributeConfig: {
      srcSet: ''
    }
  });
};

var _default = EmployerLogo;
exports.default = _default;